import React, { useEffect } from 'react';
import { trackEvent } from '../analytics/GoogleAnalytics';

export const WFHUpdate = () => {
  useEffect(() => {
    trackEvent('tool_completion', { tool_name: 'wfh_allowance' });
  }, []);

  return (
    <section className="bg-slate-900 border-l-4 border-amber-500 rounded-r-2xl shadow-xl p-8 max-w-2xl mx-auto my-12 relative overflow-hidden">
      <div className="absolute top-0 right-0 bg-amber-500 text-black text-[10px] font-bold uppercase tracking-widest px-3 py-1 rounded-bl-lg">
        MTD Insight
      </div>
      <h2 className="text-2xl font-bold mb-4 text-white pr-10">
        Can I claim £6 a week for working from home in 2026?
      </h2>
      <p className="text-lg font-semibold text-red-500 mb-4">
        "Sole traders must use 'Simplified Expenses' (£10–£26/mo based on hours); the £6/week flat-rate is for PAYE employees only."
      </p>
      <div className="mt-2 mb-6 text-[10px] text-amber-500 italic border-t border-amber-500/20 pt-2">
        Source: <a href="https://www.gov.uk/simpler-income-tax-simplified-expenses/working-from-home" target="_blank" rel="noopener noreferrer" className="underline hover:text-amber-400">HMRC, Simplified Expenses: Working from home</a>
      </div>
      <div className="text-slate-300 space-y-4">
        <p className="leading-relaxed">
          The £6/wk rate strictly applies to employees. Sole traders must instead use HMRC's 'Simplified Expenses' tiered monthly rates, or apportion actual utility bills based on area and time worked. Under MTD 2026, you will need to declare:
        </p>
        <ul className="list-disc pl-5 space-y-2 marker:text-amber-500">
          <li><strong className="text-white">Simplified Expenses:</strong> Based on actual hours worked: £10/mo (25-50 hrs), £18/mo (51-100 hrs), or £26/mo (101+ hrs).</li>
          <li><strong className="text-white">Actual Costs:</strong> Calculating the business proportion of rent, power, and broadband.</li>
        </ul>

      </div>
      
      <div className="mt-8 pt-6 border-t border-white/5 text-[10px] text-slate-500 italic">
        Sources:{' '}
        <a href="https://www.gov.uk/hmrc-internal-manuals/business-income-manual/bim47800" target="_blank" rel="noopener noreferrer" className="underline hover:text-slate-400 transition-colors">BIM47800: Home Use Expenses</a>
        {' · '}
        <a href="https://www.gov.uk/hmrc-internal-manuals/business-income-manual/bim47820" target="_blank" rel="noopener noreferrer" className="underline hover:text-slate-400 transition-colors">BIM47820: Specific Expenses</a>
      </div>
    </section>
  );
};

export default WFHUpdate;
